<template>
  <div>
    <modal-template
      v-show="toggle"
      @close="toggleInfoModal"
      class="override-modal"
    >
      <template #header>
        <i class="icon-ic_close" @click="toggleInfoModal" />
        <h3>{{ $t('botoes.indisponivel') }}</h3>
      </template>
      <template #body>
        <p>
          O documento <strong>{{ procedure }}</strong> não está disponível.
        </p>
        <p class="procedure">Como proceder:</p>
        <p>
          Para maiores informações entre em contato com o Atendimento Online
          (chat).
        </p>
      </template>
      <template #footer>
        <b-button class="btn-orange" @click="irParaChat">
          {{ $t('botoes.chat') }}
        </b-button>
      </template>
    </modal-template>
  </div>
</template>

<script>
import ModalTemplate from '../modal/ModalTemplate'
export default {
  name: 'UnavailableExam',
  components: { ModalTemplate },
  props: {
    procedure: {
      type: String,
      default: () => ''
    },
    toggle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleInfoModal() {
      this.$emit('closeModal', 'unavailableExam')
    },
    irParaChat() {
      this.toggleInfoModal()
      this.redirectToChat()
    },
    redirectToChat() {
      window.open('http://www.sarah.br/chat')
    }
  }
}
</script>

<style lang="scss" scoped src="@/assets/stylesheets/components/shared/modal/UnavailableExam.scss"></style>
